import { render, staticRenderFns } from "./ProposalConfirmation.vue?vue&type=template&id=0cbadb0c&scoped=true&"
import script from "./ProposalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProposalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProposalConfirmation.vue?vue&type=style&index=0&id=0cbadb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbadb0c",
  null
  
)

export default component.exports